import React from "react";
import GoogleMapReact, { Props } from "google-map-react";
import Marker from "./Marker";

interface MapProps
    extends Omit<
        Props,
        | "bootstrapURLKeys"
        | "defaultCenter"
        | "yesIWantToUseGoogleMapApiInternals"
        | "defaultZoom"
    > {
    latitude?: number;
    longitude?: number;
    accurateAddress?: boolean;
    googleApiToken?: string;
}

const Map: React.FC<MapProps> = ({
    latitude,
    longitude,
    accurateAddress,
    googleApiToken,

    ...rest
}) => {
    const mapCenter = { lat: latitude, lng: longitude };

    return (
        <div style={{ height: "100vh", width: "100%" }}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: googleApiToken }}
                defaultCenter={mapCenter}
                yesIWantToUseGoogleMapApiInternals
                defaultZoom={accurateAddress == true ? 15 : 11}
                {...rest}
            >
                {accurateAddress == true && (
                    <Marker lat={latitude} lng={longitude} />
                )}
            </GoogleMapReact>
        </div>
    );
};

export { Map, MapProps };
